import React from 'react'
import classNames from 'classnames'
import { ReactComponent as Arrow } from 'assets/icons/Arrow.svg'

const Pagination = ({ currentPage, pageSize, totalCount, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / pageSize)

  if (totalPages === 1) return null

  const pages = []
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i)
  }

  const getPageNumbers = () => {
    const minPage = Math.max(1, currentPage - 2)
    const maxPage = Math.min(totalPages, currentPage + 2)

    const pageNumbers = []

    for (let i = minPage; i <= maxPage; i++) {
      if (i !== 1 && i !== totalPages) pageNumbers.push(i)
    }

    return pageNumbers
  }

  const pageNumbers = getPageNumbers()
  const renderPages = () => {
    return pageNumbers.map((page) => (
      <li
        key={page}
        className={classNames(
          page === currentPage ? 'bg-[#5d55e8] rounded-full w-6' : 'w-6',
        )}
      >
        <button
          className={classNames(
            page === currentPage
              ? 'hover:cursor-default'
              : 'hover:cursor-pointer hover:bg-[#5d55e8] rounded-full',
            'text-[16px] w-6 ',
          )}
          onClick={() => onPageChange(page)}
        >
          {page}
        </button>
      </li>
    ))
  }

  return (
    <nav>
      <ul className="flex gap-4">
        <li className={classNames(1 === currentPage ? 'hidden' : '', ' w-6')}>
          <button
            className="text-[16px] w-6 h-[20px]  hover:cursor-pointer  rounded-full"
            onClick={() => onPageChange(currentPage - 1)}
          >
            <Arrow className="w-4 h-3 rotate-180	" />
          </button>
        </li>
        <li className="w-6">
          <button
            className={classNames(
              1 === currentPage
                ? 'hover:cursor-default bg-[#5d55e8] rounded-full text-white'
                : 'hover:cursor-pointer hover:bg-[#A9A9A9] rounded-full',
              'text-[16px] w-6 ',
            )}
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
          >
            1
          </button>
        </li>
        {pageNumbers[0] > 2 && (
          <li className="w-6">
            <span className="text-[16px] w-6 ">...</span>
          </li>
        )}
        {renderPages()}
        {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
          <li className="w-5">
            <span className="text-[16px] w-6">...</span>
          </li>
        )}
        {totalPages > 1 && (
          <li className="w-6">
            <button
              className={classNames(
                totalPages === currentPage
                  ? 'hover:cursor-default bg-[#5d55e8] rounded-full text-white'
                  : 'hover:cursor-pointer hover:bg-[#A9A9A9] rounded-full',
                'text-[16px] w-6 ',
              )}
              onClick={() => onPageChange(totalPages)}
              disabled={currentPage === totalPages}
            >
              {totalPages}
            </button>
          </li>
        )}
        <li
          className={classNames(
            totalPages === currentPage ? 'hidden' : '',
            ' w-6',
          )}
        >
          <button
            className="text-[16px] w-6 h-[20px] hover:cursor-pointer"
            onClick={() => onPageChange(currentPage + 1)}
          >
            <Arrow className="w-4 h-3 	" />
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default Pagination
